import React from 'react';
import { Link } from 'react-router-dom';
import "../styles/hero.css";

const Hero = () => {
  return (
    <div className="hero">
      <div className="hero-content">
        <div className="hero-text">
          <h1 className='hero-title'>
            Real World Metric Generation
          </h1>
          <h2 className='h2'>Make decisions based on real world data.</h2>
          <li>Visitor Counter</li>
          <li>Age & Gender Demographics</li>
          <li>Detailed Reports & Dashboard</li>





    
          <div className="hero-links">
            <Link to="/metric-generator" className="hero-about-link">
              AI Sensor
            </Link>
            <Link to="/contact" className="hero-contact-link">
              Contact us
            </Link>
          </div>
        </div>
      </div>
      <div className="video-container">
        <div className="gradient-overlay"></div>
         <img src={require('../assets/misc/bg_hosting.png')} alt="Metric People"  />
      </div>
    </div>
  );
};

export default Hero;